import React, { createContext } from 'react';

const ScreenContainerContext = createContext(null);

export const ScreenContainerProvider = ({ children }) => {

    // Ensure that the context is not undefined
    if (!children) {
        console.error("ScreenContainerProvider must have children");
        return null;
    }

    return (
        <ScreenContainerContext.Provider>
            {children}
        </ScreenContainerContext.Provider>
    );
};